// extracted by mini-css-extract-plugin
export var headerXL = "FormSection-module--headerXL--1gha3";
export var headerL = "FormSection-module--headerL--1jSkM";
export var headerM = "FormSection-module--headerM--11OJz";
export var headerS = "FormSection-module--headerS--2u0yn";
export var headerXS = "FormSection-module--headerXS--NNEZx";
export var blogHeaderXL = "FormSection-module--blogHeaderXL--2GhQ4";
export var blogHeaderL = "FormSection-module--blogHeaderL--n9MgP";
export var blogHeaderM = "FormSection-module--blogHeaderM--3nyhR";
export var blogHeaderS = "FormSection-module--blogHeaderS--1xCTG";
export var blogHeaderXS = "FormSection-module--blogHeaderXS--yMAE5";
export var headerPreamble = "FormSection-module--headerPreamble--3NLFc";
export var preHeader = "FormSection-module--preHeader--1qvRW";
export var textNormal = "FormSection-module--textNormal--v4AFv";
export var textSmall = "FormSection-module--textSmall--3GUcB";
export var textSmallAlternate = "FormSection-module--textSmallAlternate--LiHLT";
export var legend = "FormSection-module--legend--3rXBx";
export var caption = "FormSection-module--caption--1tbFM";
export var gradientBackground = "FormSection-module--gradientBackground--TnnzX";
export var ellipsis = "FormSection-module--ellipsis--3MMeQ";
export var globalContainer = "FormSection-module--globalContainer--1wZPl";
export var maxWidth = "FormSection-module--maxWidth--3g-xg";
export var clipBottom = "FormSection-module--clipBottom--1Znb1";
export var clipTopBottom = "FormSection-module--clipTopBottom--2S1pT";
export var section = "FormSection-module--section--35Dus";
export var container = "FormSection-module--container--3AIEt";
export var descriptionSection = "FormSection-module--descriptionSection--1bFIV";
export var descriptionTitle = "FormSection-module--descriptionTitle--3bo-_";
export var descriptionText = "FormSection-module--descriptionText--3KD2F";
export var formSection = "FormSection-module--formSection--zS_Y_";
export var formTitle = "FormSection-module--formTitle--3xa5I";
export var formDescription = "FormSection-module--formDescription--1d1PW";
export var formSubmitButton = "FormSection-module--formSubmitButton--2hbUA";
export var formDisclaimer = "FormSection-module--formDisclaimer--2e2T0";
export var hidden = "FormSection-module--hidden--39Naf";
export var ch2 = "FormSection-module--ch2--1S9YF";
export var ch2Container = "FormSection-module--ch2-container--1Otzq";